import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { SituacaoFinanceiraPorExtenso } from 'src/tipos'

export const colunaSituacaoFinanceira = (): TabelaColuna => ({
  Chave: 'situacaoFinanceira',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <>{SituacaoFinanceiraPorExtenso[linha.situacaoFinanceira]}</>
  ),
  RenderizarCabecalho: () => (
    <div style={{ width: 150 }}>Situação Matrícula</div>
  )
})
